/**
 * Homepage / marketing videos — prefer Cloudflare R2 (or any CDN) so Render
 * does not serve multi‑MB MP4/WebM bandwidth.
 *
 * Set in the client build env (Render static site / CRA):
 *   REACT_APP_VIDEO_CDN_BASE=https://videos.yourdomain.com
 * or
 *   REACT_APP_VIDEO_CDN_BASE=https://pub-xxxxx.r2.dev
 *
 * Paths are always under /videos/... locally when the env is unset (dev fallback).
 */

const CDN_BASE = String(process.env.REACT_APP_VIDEO_CDN_BASE || '')
  .trim()
  .replace(/\/+$/, '');

/**
 * @param {string} fileName e.g. "hero.mp4" or "/videos/hero.mp4"
 * @returns {string} absolute CDN URL or same-origin /videos/... path
 */
export function videoCdnUrl(fileName) {
  const raw = String(fileName || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:')) return raw;

  const name = raw.replace(/^\/?videos\//, '').replace(/^\//, '');
  if (!name) return '';

  if (CDN_BASE) {
    return `${CDN_BASE}/videos/${name}`;
  }
  return `/videos/${name}`;
}

export function isVideoCdnConfigured() {
  return Boolean(CDN_BASE);
}

export const HOME_VIDEOS = {
  heroMp4: () => videoCdnUrl('hero.mp4'),
  heroWebm: () => videoCdnUrl('hero.webm'),
  founderMp4: () => videoCdnUrl('founder.mp4'),
  playerLoginMp4: () => videoCdnUrl('Player_Login.mp4'),
};
